<template>
  <a-card :title="enterpriseFullName+'/认证设置'" :bordered="false" :headStyle="{ fontSize: '18px' }">
    <a-form-model
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :label-col="currentFormLayout2.labelCol"
      :wrapper-col="currentFormLayout2.wrapperCol"
    >
      <a-form-model-item label="认证方式" prop="authMethods">
        <a-checkbox-group v-model:value="ruleForm.authMethods">
          <a-checkbox :value="1">公司邮箱</a-checkbox>
          <a-checkbox :value="2">手机号</a-checkbox>
          <a-checkbox :value="3">钉钉认证</a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item v-if="ruleForm.authMethods&&ruleForm.authMethods.includes(1)" label="公司邮箱域名"
                         prop="enterpriseEmailDomain">
        <a-input v-model="ruleForm.enterpriseEmailDomain" allowClear :maxLength="100"
                 placeholder="请输入如yuming.com,不带www" style="width: 600px;"/>
      </a-form-model-item>

      <template v-if="ruleForm.authMethods&&ruleForm.authMethods.includes(3)">
        <a-form-model-item label="钉钉Client ID" prop="dingTalkAppKey">
          <a-input v-model="ruleForm.dingTalkAppKey" allowClear :maxLength="100" placeholder="请输入钉钉Client ID"
                   style="width: 600px;"/>
        </a-form-model-item>
        <a-form-model-item label="钉钉Client Secret" prop="dingTalkAppSecret">
          <a-input v-model="ruleForm.dingTalkAppSecret" allowClear :maxLength="100"
                   placeholder="请输入钉钉Client Secret" style="width: 600px;"/>
        </a-form-model-item>
        <a-form-model-item label="钉钉Client CorpId" prop="dingTalkCorpId">
          <a-input v-model="ruleForm.dingTalkCorpId" allowClear :maxLength="100" placeholder="请输入钉钉Client CorpId"
                   style="width: 600px;"/>
        </a-form-model-item>
        <a-form-model-item label="钉钉Client AgentId" prop="dingTalkAgentId">
          <a-input v-model="ruleForm.dingTalkAgentId" allowClear :maxLength="100" placeholder="请输入钉钉Client AgentId"
                   style="width: 600px;"/>
        </a-form-model-item>
      </template>

      <a-form-model-item :wrapper-col="currentFormLayout2.offsetCol">
        <a-button type="primary" @click="handleSubmit" :loading="submitLoading">提交</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>
<script>
import ruleFormLayout from '@/utils/mixins/ruleFormMixins'
import employeeOptions from '@/views/platform/employeeVerification/mixins/employeeMixins'

export default {
  name: 'AuthenticationSettings',
  mixins: [ruleFormLayout, employeeOptions],
  data() {
    // //钉钉企业id：dingTalkCorpId;
    // 钉钉应用id：dingTalkAgentId;
    // 钉钉client ID：dingTalkAppKey;
    // 钉钉client Secret：dingTalkAppSecret;
    return {
      ruleForm: {
        enterpriseEmailDomain: undefined,
        authMethods: [],
        dingTalkCorpId: undefined,//钉钉企业id
        dingTalkAgentId: undefined,//钉钉应用id
        dingTalkAppKey: undefined,//钉钉client ID
        dingTalkAppSecret: undefined//钉钉client Secret
      },
      submitLoading: false,
      rules: {
        enterpriseEmailDomain: [{ required: true, message: '请输入公司邮箱域名', trigger: 'blur' }],
        dingTalkAppSecret: [{ required: true, message: '请输入钉钉Client Secret', trigger: 'blur' }],
        dingTalkAppKey: [{ required: true, message: '请输入钉钉Client ID', trigger: 'blur' }],
        dingTalkAgentId: [{ required: true, message: '请输入钉钉Client AgentId', trigger: 'blur' }],
        dingTalkCorpId: [{ required: true, message: '请输入钉钉Client CorpId', trigger: 'blur' }],
        authMethods: [{ required: true, message: '请选择认证方式', trigger: 'change' }]
      }
    }
  },
  watch: {
    'ruleForm.productType': function(val) {
      if (this.ruleForm.productType === 2) {
        this.ruleForm.enterpriseEmailDomain = undefined
      }
    },
    'enterpriseId': function(val) {
      if (this.enterpriseId) {
        this.getDetails(this.enterpriseId)
      }
    }
  },
  mounted() {
    this.getDetails(this.enterpriseId)
  },
  methods: {
    getDetails(enterpriseId) {
      const url = `member/v3/auth/getEnterpriseDetail/${enterpriseId}`
      this.getHttpServices().getMemberAuthService().post(url)
        .then(data => {
          this.ruleForm = { ...data }
        })
        .catch(err => {
          console.error(err)
          this.$message.error('操作失败，请重试！')
        })
    },
    requestSave() {
      const url = 'member/v3/auth/updateAuthEnterpriseMethod'
      this.getHttpServices().getMemberAuthService().post(url, { ...this.ruleForm, enterpriseId: this.enterpriseId })
        .then(res => {
          //console.error('===requestSave==',res)
          this.$message.success('操作成功！')
        })
        .catch(err => {
          console.error(err)
          if (err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('操作失败，请重试！')
          }
        })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        //console.error('=handleSubmit=ruleForm==',this.ruleForm)
        if (valid) {
          this.requestSave()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          this.$message.error('请完善相关事情！')
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">

</style>